

















































































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { IBarcodeItem } from "../../../../../../domain/editableFormat/objects/IBarcodeObject";
import { IBarcodeInformationSpecification } from "../../../../../../domain/editableFormat/IFormatSpecification";
import { BarcodeItemSelector } from "../selectors";

@Component({
  components: {
    BarcodeItemSelector
  }
})
export default class BarcodeItemEditDialog extends Mixins(DialogMixin) {
  items: IBarcodeItem[] = [];
  selectionItems: IBarcodeItem[] = [];
  barcodeInformations: IBarcodeInformationSpecification[] = [];
  selectedItems: IBarcodeItem[] = [];
  selectedSelectionItems: IBarcodeItem[] = [];
  edittingString: string = "";
  confirmed: boolean = false;

  get hasEdittingString(): boolean {
    return this.edittingString !== "";
  }

  get hasSelectedItems(): boolean {
    return this.selectedItems.length > 0;
  }

  get isTopSelectedItem(): boolean {
    return this.hasSelectedItems && this.selectedItems.some(v => v === this.items[0]);
  }

  get isBottomSelectedItem(): boolean {
    return this.hasSelectedItems && this.selectedItems.some(v => v === this.items[this.items.length - 1]);
  }

  get hasSelectedSelectionItems(): boolean {
    return this.selectedSelectionItems.length > 0;
  }

  async show(items: IBarcodeItem[], barcodeInformations: IBarcodeInformationSpecification[]): Promise<IBarcodeItem[]> {
    return this.showModal(async () => {
      this.items = ObjectUtility.copyDeeply(items);
      this.selectionItems = this.toSelectionItems(barcodeInformations);
      this.barcodeInformations = barcodeInformations;
      this.selectedItems = [];
      this.selectedSelectionItems = [];
      this.edittingString = "";
      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed ? this.items : null;
    });
  }

  private toSelectionItems(items: IBarcodeInformationSpecification[]): IBarcodeItem[] {
    return items.map(v => {
      return {
        isHisItem: true,
        value: v.key,
      };
    });
  }

  addString() {
    this.items = this.items.concat({
      isHisItem: false,
      value: this.edittingString,
    });
  }

  addSelectionItems() {
    this.items = this.items.concat(ObjectUtility.copyDeeply(this.selectedSelectionItems));
  }

  moveItems(offset: number) {
    const indexes = this.selectedItems.map(v => this.items.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.items[index];
    this.items.splice(index, 1);
    this.items.splice(index + offset, 0, item);
  }

  removeItems() {
    this.items = this.items.filter((v) => !this.selectedItems.some(s => s === v));
  }

  changeItems(value: IBarcodeItem[]) {
    this.selectedItems = value;
  }

  changeSelectionItems(value: IBarcodeItem[]) {
    this.selectedSelectionItems = value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
